import API from "Helpers/API";
import UserEntryDataService from "Helpers/UserEntryDataService";

export const saveUserEntryData = (data) => {
  new UserEntryDataService(new API()).saveEntryData(data);
};
